import * as React from 'react';

import { StyledHeader } from './style';

interface TableHeaderProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const TableHeader: React.FC<TableHeaderProps> = ({ children, style }) => {
  return (
    <StyledHeader style={style}>
      <span className="wrapper">{children}</span>
    </StyledHeader>
  );
};

export default TableHeader;
